module.exports = __webpack_public_path__ + "img/profile.a30c6949.png";